import React from 'react';
import { Construction } from 'lucide-react';

/**
 * Generic "Coming soon" placeholder shown to admins when they click into a sidebar
 * item that is still marked "Snart" but hasn't been built yet (Storyblok,
 * Schemaläggare, Marknadsplan). Non-admins can't reach this — they see locked
 * items in the sidebar.
 */
export default function ComingSoonPage({ title, description }) {
  return (
    <div className="page-scroll" data-testid="coming-soon-page">
      <div className="page-header">
        <h1 className="page-title">{title}</h1>
        <p className="page-subtitle">{description}</p>
      </div>

      <div style={{
        marginTop: 48,
        background: '#fff',
        border: '1px solid #e2e8f0',
        borderRadius: 16,
        padding: '64px 32px',
        textAlign: 'center',
        boxShadow: '0 1px 3px rgba(0,0,0,0.04)',
      }}>
        <div style={{
          width: 72, height: 72, borderRadius: '50%',
          background: 'linear-gradient(135deg, #fef3c7, #fde68a)',
          display: 'flex', alignItems: 'center', justifyContent: 'center',
          margin: '0 auto 20px',
        }}>
          <Construction size={32} color="#b45309" />
        </div>
        <h2 style={{ margin: '0 0 8px', fontSize: 22, fontWeight: 700, color: '#0f172a' }}>
          Snart här
        </h2>
        <p style={{ margin: 0, fontSize: 14, color: '#64748b', maxWidth: 480, marginLeft: 'auto', marginRight: 'auto' }}>
          Den här modulen är under utveckling och kommer snart bli tillgänglig.
          Du som admin ser den här platshållaren — vanliga användare ser endast
          låst <em>Snart</em>-status i sidofältet.
        </p>
      </div>
    </div>
  );
}
